import React, { useContext, useState } from "react";
import { Button, Row } from "react-bootstrap";
import Modal from "../../../../../_components/Modal";
import styled from "styled-components";
import AppContext from "../../../context";
import { getMaxCode, importNFEData, validateProductRefCode } from "../../../../../api/products";
import { SelectICMS } from "@taxes";
import { notification } from "antd";
import { saveProduct } from "../../../../../components/pages/products/utils";
import CurrencyInput from "react-currency-input";
import { showSnackBar } from "../../../../../utils";
import { supportPhoneNumber } from "../../../../../utils";

const ContainerDragAndDrop = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
  max-width: 300px;
  padding-top: 30px;
  cursor: pointer;
  border: 3px dotted #ebebeb;
  i {
    font-size: 4em;
    font-weight: bold;
  }
`

function ImportXML({ closeFirstModal }) {

    const {
        baseProductName,
        setBaseProductName,
        ncm,
        setNcm,
        cfop,
        setCfop,
    } = useContext(AppContext);

    const [selectedXML, setSelectedXML] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [allowedImport, setAllowedImport] = useState(false);
    const [error, setError] = useState("");
    const [disabled, setDisabled] = useState(false);
    const [importedProducts, setImportedProducts] = useState([]);
    const [modalProducts, setModalProducts] = useState(false);
    // Controle de conflitos de código (cProd já existente)
    const [conflictProduct, setConflictProduct] = useState(null); // { index, cprod, newCode }
    const [conflictInput, setConflictInput] = useState("");

    function containsUnicodeCharacter(input) {

        for (let i = 0; i < input.length; i++) {
            if (input.charCodeAt(i) > 127 && !/[a-zA-Zçáéíóúâêôãõ]/.test(input[i])) {
                return true;
            }
        }
        return false;
    }

    function onSelectFile(e) {
        if (e.target.files[0].type !== "text/xml") {
            setError("Arquivo inválido! Selecione um arquivo XML válido.");
            setSelectedXML(e.target.files[0]);
            setAllowedImport(false);
            return;
        }
        setError("");
        setSelectedXML(e.target.files[0]);
        setAllowedImport(true);
    }


    function click() {
        const inputFile = document.getElementById(
            "import-xml-nfe-laksjdalsi-askdjhasd"
        );
        inputFile.value = "";
        inputFile.click();
    }


    function openModal() {
        setSelectedXML({});
        if (importedProducts.length) {
            setModalProducts(true);
        } else {
            setShowModal(true);
        }
    }


    function importData() {

        importNFEData(selectedXML, "xml")

            .then((response) => {

                setImportedProducts(response.itens);

                setDisabled(true);

                setShowModal(false);

                setModalProducts(true);

                setError("");

            })

            .catch((err) => {

                setError("Erro no XML! Selecione um XML Válido.");

            });

    }


    function setIcmsItens(icms) {

        let temp = [...importedProducts];

        for (let i = 0; i < temp.length; i++) {

            temp[i].icms = icms;

            if (temp[i].icms.name === "Selecione o icms") {

                setDisabled(true);

            } else {

                setDisabled(false);

            }

        }
        setImportedProducts(temp);

    }


    async function createProduct() {

        const payload = () => {
            notification.open({
                type: "success",
                message: "Produto(s) cadastrado(s)",
                description: (
                    <p><span>Produto(s) cadastrado(s) com sucesso</span></p>
                ),
            });
            setTimeout(() => {
                window.location.href = `/products`;
            }, 500);
        };

        function errorPayload(err) {
            let data = JSON.parse(err.response);
            for (let i = 0; i < data.length; i++) {
                const element = data[i];
                if (element.code && element.code[0]) {
                    showSnackBar('O campo <cProd/> precisa ser único.');
                }
            }
        }

        // Monta a lista aplicando o cProd do XML como ref_code.
        // Valida cada código e, se houver conflito, abre o modal de resolução.
        let product_list = [];
        let maxCode = await getMaxCode();

        for (let i = 0; i < importedProducts.length; i++) {
            const prod = importedProducts[i];
            let ref_code = prod.ref_code_override !== undefined
                ? prod.ref_code_override
                : (prod.cprod || String(maxCode.max_code + i + 1));

            // Verifica duplicidade somente se o código ainda não foi resolvido pelo usuário.
            // A API retorna 200 quando o código é único e 400 quando já existe (rejeita a Promise).
            if (prod.ref_code_override === undefined && prod.cprod) {
                let isDuplicate = false;
                try {
                    await validateProductRefCode(prod.cprod);
                    // 200 = código único, pode prosseguir
                } catch (err) {
                    // 400 = código já cadastrado → conflito
                    isDuplicate = true;
                }
                if (isDuplicate) {
                    const nextAutoCode = maxCode.max_code + i + 1;
                    setConflictProduct({ index: i, cprod: prod.cprod, newCode: nextAutoCode });
                    setConflictInput(String(prod.cprod));
                    return; // Interrompe; o usuário vai escolher e createProduct será chamado novamente
                }
            }

            product_list.push({
                ref_code,
                name: prod.descricao,
                barcode: prod.barcode,
                unit: prod.unidade && prod.unidade.id,
                price: prod.valor_venda,
                cost: prod.valor_custo,
                fiscal: {
                    ncm: prod.ncm && prod.ncm.id,
                    cfop: prod.cfop && prod.cfop.id,
                    template_icms: prod.icms && prod.icms.id,
                },
            });
        }

        saveProduct(product_list, payload, errorPayload, true);
    }


    function EditValue({ value, index }) {

        return (

            <CurrencyInput

                name="price"

                value={value}

                prefix="R$ "

                decimalSeparator="."

                onChange={(a, b) => {

                    let tempList = [...importedProducts];

                    tempList[index].valor_venda = b;

                    setImportedProducts(tempList);

                }}

                className="form-control"

            />

        );

    }


    // Resolve conflito: o usuário escolheu manter, usar novo código ou digitar um customizado
    function resolveConflict(chosenCode) {
        const idx = conflictProduct.index;
        const updated = [...importedProducts];
        updated[idx] = { ...updated[idx], ref_code_override: chosenCode };
        setImportedProducts(updated);
        setConflictProduct(null);
        // Retoma o cadastro automaticamente após a resolução
        setTimeout(() => createProduct(), 0);
    }


    return (

        <div>

            <input

                accept="text/xml"

                onChange={onSelectFile}

                id="import-xml-nfe-laksjdalsi-askdjhasd"

                type="file"

                className="d-none"

            />

            <Button onClick={openModal}>Importar via XML</Button>

            <Modal

                title="Importar produto via XML de NFe"

                show={showModal}

                onHide={() => setShowModal(false)}

            >

                {selectedXML.name && selectedXML.size < 500000 ? (

                    <div>

                        {error.length ? (

                            <h4 className="text-danger text-center">{error}</h4>

                        ) : null}

                        <h3 className="text-center">{selectedXML.name}</h3>

                    </div>

                ) : (

                    <div className="d-flex justify-content-center w-100 flex-column">

                        <ContainerDragAndDrop onClick={click}>

                            <i className="fas fa-file-upload text-info"></i>

                        </ContainerDragAndDrop>

                        <h3 className="text-info text-center">Selecione um XML</h3>

                    </div>

                )}

                {selectedXML.size >= 500000 ? (

                    <h2 className="text-center font-bold">

                        Arquivo muito pesado! (Max. de 500kB)

                        <br />

                        fale com o{" "}

                        <a

                            target="_blank"

                            href={`https://wa.me/${supportPhoneNumber}`}

                        >

                            Suporte

                        </a>{" "}

                        para mais informações.

                    </h2>

                ) : (

                    <div className="d-flex flex-row-reverse">

                        <Button disabled={!allowedImport} onClick={importData}>

                            Importar

                        </Button>

                    </div>

                )}

            </Modal>


            <Modal

                title="Produtos Encontrados"

                show={modalProducts}

                onHide={() => setModalProducts(false)}

            >

                <table className="table table-responsive-sm table-hover">

                    <thead>

                        <tr>

                            <th scope="col">#</th>

                            <th scope="col">Cód.</th>

                            <th scope="col">Nome</th>

                            <th scope="col">Preço de venda</th>

                            <th scope="col">Preço de custo</th>

                            <th scope="col">NCM</th>

                            <th scope="col">CFOP</th>

                        </tr>

                    </thead>

                    <tbody>

                        {importedProducts.map((prod, index) => (

                            <tr key={index}>

                                <td>{index + 1}</td>

                                <td>
                                    {prod.ref_code_override !== undefined ? prod.ref_code_override : (prod.cprod || "N/A")}
                                </td>

                                <td>{prod.descricao || "N/A"}</td>

                                <td>

                                    <EditValue index={index} value={prod.valor_venda} />

                                </td>

                                <td>R$ {prod.valor_custo || "N/A"}</td>

                                <td>{prod.ncm && prod.ncm.code ? prod.ncm.code : "N/A"}</td>

                                <td>{prod.cfop && prod.cfop.code ? prod.cfop.code : "N/A"}</td>

                            </tr>

                        ))}

                    </tbody>

                </table>

                <Row className="justify-content-between col-12">

                    <SelectICMS onChangeIcms={setIcmsItens} />

                    <Button

                        onClick={createProduct}

                        disabled={disabled}

                        style={{ flexDirection: "column", alignSelf: "flex-end" }}

                    >

                        Cadastrar {importedProducts.length > 1 ? "itens" : "item"}

                    </Button>

                </Row>

            </Modal>

            {/* Modal de conflito de código */}
            <Modal
                title="Conflito de código de produto"
                show={!!conflictProduct}
                onHide={() => setConflictProduct(null)}
            >
                {conflictProduct && (
                    <div>
                        <p style={{ marginBottom: "8px" }}>
                            O código <strong style={{ fontFamily: "monospace" }}>{conflictProduct.cprod}</strong> (cProd do XML)
                            já está cadastrado em outro produto do sistema.
                        </p>
                        <p style={{ marginBottom: "16px", color: "#555" }}>
                            Escolha como deseja prosseguir para o produto{" "}
                            <strong>{importedProducts[conflictProduct.index] && importedProducts[conflictProduct.index].descricao}</strong>:
                        </p>

                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "16px" }}>
                            <Button
                                variant="outline-primary"
                                onClick={() => resolveConflict(conflictProduct.cprod)}
                            >
                                Manter código do XML ({conflictProduct.cprod})
                            </Button>
                            <Button
                                variant="outline-secondary"
                                onClick={() => resolveConflict(String(conflictProduct.newCode))}
                            >
                                Usar próximo código disponível ({conflictProduct.newCode})
                            </Button>
                        </div>

                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Ou digite um código manualmente..."
                                value={conflictInput}
                                onChange={(e) => setConflictInput(e.target.value)}
                                style={{ maxWidth: "260px" }}
                            />
                            <Button
                                variant="success"
                                disabled={!conflictInput.trim()}
                                onClick={() => resolveConflict(conflictInput.trim())}
                            >
                                Usar este código
                            </Button>
                        </div>
                    </div>
                )}
            </Modal>

        </div>

    );

}

export default ImportXML;



// WEBPACK FOOTER //
// ./src/views/AppViews/Products/imports/NFeXML/index.jsx